/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { processFormActions, getFormDefaultState } from '@insticator/insticator-ui'; // iui-utils
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';



/* ========== ~~~~~~~~~~  PROFILE STATUS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const transpilePersonalInformationData = (data) => ({
    fname: { value: !!data.firstName ? data.firstName : '', valid: !!data.firstName ? true : null }, // valid: null / true / false
    lname: { value: !!data.lastName ? data.lastName : '', valid: !!data.lastName ? true : null },
    email: { value: !!data.email ? data.email : '', valid: !!data.email ? true : null },
    phone: { value: !!data.phoneNumber ? data.phoneNumber : '', valid: !!data.phoneNumber ? true: null },
});

const transpilePasswordData = data =>({
    currentpassword: { value: !!data.currentpassword ? data.currentpassword : '', valid: !!data.currentpassword ? true : null },
    newpassword: { value: !!data.newpassword ? data.newpassword : '', valid: !!data.newpassword ? true : null },
    repeatpassword: { value: !!data.repeatpassword ? data.repeatpassword : '', valid: !!data.repeatpassword ? true : null }
});




//-=-=-=-=-=-=-=-=-=-=-= Default State -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

const defaultState = {
    personalInformationForm: getFormDefaultState(transpilePersonalInformationData),
    changePasswordForm: getFormDefaultState(transpilePasswordData),
};

const transpilerSelector = (formName) =>{
    switch (formName) {
        case 'changePasswordForm':
            return transpilePasswordData;
        case 'personalInformationForm':
            return transpilePersonalInformationData;
        default:
            return null;
    }
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const assignedForms = Object.keys(defaultState);

const profileStatus = (state = defaultState, action) => {
    if (action.type.startsWith('FORM_') && assignedForms.includes(action.formName)) {
        return processFormActions(state, action, action.formName, transpilerSelector(action.formName))
    }
    switch (action.type) {
        case CLEAR_ALL_STATES:
            return defaultState;
        default:
            return state;
    }
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default profileStatus;